import { render, staticRenderFns } from "./AudioIndexComponent.vue?vue&type=template&id=f156161c&"
import script from "./AudioIndexComponent.vue?vue&type=script&lang=js&"
export * from "./AudioIndexComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports